export const flattenPaginatedNodes = (response) => {
    if (response === null) {
        return {
            nodes: [],
            pageInfo: {
                endCursor: null,
                hasNextPage: false,
            },
            totalCount: 0,
        };
    }
    const nodes = response.edges.map((e) => ({
        ...e.node,
        _cursor: e.cursor,
    }));
    return {
        ...response,
        nodes,
    };
};
export const mapPaginatedResponse = (response, mapPredicate) => ({
    ...response,
    edges: response.edges.map((edge) => ({
        ...edge,
        node: mapPredicate(edge.node),
    })),
});
//# sourceMappingURL=api.utils.js.map